import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import {
	setModoTela, initForm
} from './lancamentoViagemActions';
import DateFormat from '../common/dateFormat/DateFormat';

class LancamentoViagemItemForm extends Component {

	state = {

	}

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
						
							<LabelAndInput
								maxWidth={180}
								name='datahora_lancamento'
								label='Data/Hora *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'}
								value={DateFormat.formatarDataHoraSqlParaTela(this.props.formularioValues.datahora_lancamento)}
								onChange={value => {
									
								}} />

							<Field
								name='id_tipo_lancamento'
								component={Select}
								options={this.props.listaTipo}
								label='Tipo *'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly} />
							
							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor *' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly}
								mask={2} />

							<Field
								name='descricao'
								component={LabelAndInput}
								label='Descrição' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
								
						</Row>
					</ContentCardBody>
					
					<ContentCardFooter>
						<Row alignCenter>
							{!this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
							</Grid>}
							{this.props.excluir &&
							<Grid cols='6 6 4 3'>
								<Button
									text='Excluir'
									submit type={'danger'}
									icon={'fa fa-trash'} />
							</Grid>}
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>

			</ContentCard>
		);
    }


}

LancamentoViagemItemForm = reduxForm({form: 'lancamentoViagemItemForm', destroyOnUnmount: false})(LancamentoViagemItemForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('lancamentoViagemItemForm')(state),
	registro: state.lancamentoViagem.registro,
	listaTipo: state.lancamentoViagem.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LancamentoViagemItemForm);
